import { createItemCache } from 'owa-items-cache';
import type { Todo } from 'owa-todo-types';
import type { TodoDescriptorWithId } from './schema/TodoDescriptor';
import { buildTodoDescriptorFilter } from './utils/filter/buildTodoDescriptorFilter';
import { containsDescriptor } from './utils/containsDescriptor';
/**
 * This creates a Todo item cache. This is the underlying storage used/ updated in this package.
 */
const todoCache = createItemCache<Todo, TodoDescriptorWithId>({
    cacheId: 'todo_item_cache',
    functions: {
        containsDescriptor: containsDescriptor,
        buildItemDescriptorFilter: buildTodoDescriptorFilter,
    },
});

export function getTodoCache() {
    return todoCache;
}
